import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import * as bootstrapBundle from 'bootstrap';
import jsKit from './jsKit';

const showSlideShow = async (url) => {
  if (!url) {
    return;
  }

  const modal = document.getElementById('popup_container_large');
  const content = modal?.querySelector('.modal-content');
  const bootstrap = bootstrapBundle;
  if (!modal || !content) {
    return;
  }

  const html = await jsKit.requestUrl(`/${url.replace(/^\/+/, '')}`, 'text');
  if (!html) {
    return;
  }

  content.innerHTML = html;
  const swiperElement = content.querySelector('#slideshow-slides');
  let swiper = null;

  modal.addEventListener('shown.bs.modal', () => {
    if (!swiperElement) {
      return;
    }

    swiper = new Swiper(swiperElement, {
      modules: [Navigation],
      direction: 'horizontal',
      loop: true,
      slidesPerView: 'auto',
      watchOverflow: true,
      navigation: {
        nextEl: content.querySelector('#slideshow-pagination #nextSlide'),
        prevEl: content.querySelector('#slideshow-pagination #prevSlide'),
      },
    });
  }, { once: true });

  modal.addEventListener('hidden.bs.modal', () => {
    swiper?.destroy(true, true);
    content.innerHTML = '';
  }, { once: true });

  bootstrap.Modal.getOrCreateInstance(modal).show();
};

export default { showSlideShow };
